module.exports = __webpack_public_path__ + "img/pdf_logo.53b3f37a.png";